"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TieComponentValue = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const signal_tie_types_1 = require("./signal-tie-types");
class TieComponentValue {
    static { this.JOINED_BY_HYPHEN = /^\s*([+-]?(?:\d+(?:\.\d*)?|\.\d+))\s*[-\u2010\u2011\u2012\u2013]\s*([A-Za-z\u00B5\u03BC\u03A9\u2126]+)\s*$/u; }
    static parse(text, componentType) {
        if (text.trim() === '') {
            return undefined;
        }
        const asWritten = TieComponentValue.tryParse(text, componentType);
        if (asWritten !== undefined) {
            return asWritten;
        }
        const unjoined = TieComponentValue.withoutJoiningHyphen(text);
        return unjoined === undefined ? undefined : TieComponentValue.tryParse(unjoined, componentType);
    }
    static format(text, componentType) {
        const value = TieComponentValue.parse(text, componentType);
        if (value === undefined) {
            return undefined;
        }
        return `${sigma_engine_shared_1.Utils.formatNumericalSIValue(value)}${signal_tie_types_1.TIE_COMPONENT_TYPE_TO_UNITS[componentType].short}`;
    }
    static parseVariance(text, componentType) {
        const trimmed = text.trim();
        if (trimmed === '') {
            return undefined;
        }
        const siDefinition = sigma_engine_shared_1.BoundaryCharacteristicSIDefinitions[signal_tie_types_1.TIE_COMPONENT_TYPE_TO_CHARACTERISTIC[componentType]];
        try {
            const properties = sigma_engine_shared_1.VarianceChecker.valueVarianceToProperties({ variance: trimmed }, siDefinition);
            if (properties === undefined || !Number.isFinite(properties.value)) {
                return undefined;
            }
            const isRelative = properties.units.short === sigma_engine_shared_1.CommonParameterUnits.percentage.short;
            return {
                variance: properties.value,
                varianceType: isRelative ? signal_tie_types_1.SignalTieVarianceType.Relative : signal_tie_types_1.SignalTieVarianceType.Absolute,
            };
        }
        catch {
            return undefined;
        }
    }
    static withoutJoiningHyphen(text) {
        const match = TieComponentValue.JOINED_BY_HYPHEN.exec(text);
        if (match === null) {
            return undefined;
        }
        const [, number, unit] = match;
        return `${number}${unit}`;
    }
    static tryParse(text, componentType) {
        const siDefinition = sigma_engine_shared_1.BoundaryCharacteristicSIDefinitions[signal_tie_types_1.TIE_COMPONENT_TYPE_TO_CHARACTERISTIC[componentType]];
        try {
            const value = sigma_engine_shared_1.Utils.parseNumericalSIValue(text, siDefinition);
            return Number.isFinite(value) ? value : undefined;
        }
        catch {
            return undefined;
        }
    }
}
exports.TieComponentValue = TieComponentValue;
//# sourceMappingURL=tie-component-value.js.map